/**
 * Which event landing pages have a resort map, and which one.
 *
 * Imported by the auth proxy (edge runtime) and the landing-page navbar/footer, so this module
 * must stay free of React and of the (large) POI data files — those are looked up by `resortId`
 * in `./data` on the server only.
 */

/** Reserved subpage slug: `/<landing-slug>/map` opens that page's resort map, behind the page's own access gate. */
export const RESORT_MAP_SUBPAGE_SLUG = "map";

export interface ResortMapLink {
  /** Key into `RESORT_MAPS` (see `./data`). */
  resortId: string;
  /** Label for the landing page's link and footer. */
  navLabel: string;
}

const RESORT_MAPS_BY_LANDING_SLUG: Record<string, ResortMapLink> = {
  "offsite-2026": { resortId: "paradisus-cancun", navLabel: "Resort map" },
};

/**
 * Looks up the resort map attached to an event landing page.
 *
 * @param landingSlug - The landing page's public slug (e.g. "offsite-2026").
 * @returns The map link, or null when that page has no map.
 */
export function getResortMapForLandingSlug(landingSlug: string | null | undefined): ResortMapLink | null {
  if (!landingSlug) return null;
  return RESORT_MAPS_BY_LANDING_SLUG[landingSlug] ?? null;
}

/**
 * Short URL of a landing page's map subpage.
 *
 * @param landingSlug - The landing page's public slug.
 * @returns e.g. "/offsite-2026/map".
 */
export function resortMapSubpageHref(landingSlug: string): string {
  return `/${encodeURIComponent(landingSlug)}/${RESORT_MAP_SUBPAGE_SLUG}`;
}
